/**
 * Força HTML novo + injeta CSS trust bar (funciona com HTML antigo em cache).
 */
(function () {
  const MIN_BUILD = '2026071608';

  function getBuild() {
    return (document.documentElement.getAttribute('data-andrade-build') || '').split('-')[1] || '';
  }

  if (document.documentElement.classList.contains('shopify-design-mode')) return;
  if (!getBuild() || getBuild() >= MIN_BUILD) return;
  if (location.search.indexOf('andrade_cb=') !== -1) return;

  try {
    if (sessionStorage.getItem('andrade-cb-tried') === MIN_BUILD) return;
    sessionStorage.setItem('andrade-cb-tried', MIN_BUILD);
  } catch (e) {}

  var url = new URL(location.href);
  url.searchParams.set('andrade_cb', MIN_BUILD);
  location.replace(url.toString());
})();
